import { SHOW_SUCCESS_BANNER } from "../../constants";

export const showSuccessBanner =
  ({ confirmationType }) =>
  dispatch => {
    dispatch({
      type: SHOW_SUCCESS_BANNER,
      payload: { showSuccessBanner: true, confirmationType }
    });
  };
